export default function hasHoverState() {
  const mediaQuery = window.matchMedia('(hover: hover)')
  return mediaQuery.matches
}
